import React, { useState, useEffect } from 'react';

import FaArrowUp from '../Assets/Images/iconArrowUp.svg'; // Usando um ícone do react-icons
import './BackToTopButton.css'; // Vamos criar um arquivo CSS para o estilo

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Função para verificar a posição da rolagem da página
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true); // Exibe o botão quando a rolagem for maior que 300px
      } else {
        setIsVisible(false); // Oculta o botão se for menor que 300px
      }
    };

    // Adiciona o event listener para o scroll
    window.addEventListener('scroll', toggleVisibility);

    // Remove o event listener ao desmontar o componente
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Função para voltar ao topo da página
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Adiciona um efeito suave para o scroll
    });
  };

  return (
      <button className="back-to-top" onClick={scrollToTop} style={{opacity:isVisible ? 1 : 0}}>
        <img src={FaArrowUp} alt="Back to top" className="noSelect" />
      </button>
  );
};

export default BackToTopButton;
